import iconTicket from 'img/icon-boleto.svg';

import ModelButton from 'components/ModelButton';
import { boletoAction, eventName } from 'components/ApplicationInsights/eventNames';

import { CTeInvoiceState } from 'models/CTEs';
import { IDownloadTypes } from 'models/Order';

import DownloadService from 'services/download.service';
import { ITableModel } from '../../interface';

const _downloadService = new DownloadService();

const billActionButton = (title?: string, size?: number) =>
  ModelButton(
    title || '',
    iconTicket,
    (data: CTeInvoiceState) =>
      _downloadService.OpenFileFromCTeInvoice(IDownloadTypes.INVOICE_BILL, data),
    eventName.BOLETO,
    size,
    boletoAction.CTE_BOLETO
  );

const labelDateOfIssue = {
  label: 'Data da Emissão',
  key: 'issueDate',
  type: 'date',
  size: 150,
  maxSize: 150,
};

const labelCNPJ = {
  label: 'CNPJ',
  key: 'documentNumber',
  type: "cnpj",
  size: 200,
  maxSize: 200
};

const labelClient = {
  label: 'Cliente',
  key: 'companyName',
  size: 300,
  maxSize: 300,
};

const labelTitle = {
  label: 'Título',
  key: 'title',
  size: 150,
  maxSize: 150,
};

const labelPortion = {
  label: 'Parcela',
  key: 'parcel',
  size: 150,
  maxSize: 150,
};

const labelDueDate = {
  label: 'Vencimento',
  key: 'dueDate',
  type: 'date',
  size: 150,
  maxSize: 150,
};

const labelValue = {
  label: 'Valor',
  key: 'price',
  type: 'currency',
  size: 150,
};

const cteModel: Array<ITableModel> = [
  labelDateOfIssue,
  labelCNPJ,
  labelClient,
  labelTitle,
  labelPortion,
  labelDueDate,
  { ...labelValue, maxSize: 150 },
];

const cteModelItems: Array<ITableModel> = [
  labelTitle,
  labelDueDate,
  labelValue,
];

const cteInvoicingModelComplete = () => {
  const model: Array<ITableModel> = [
    ...cteModel,
    billActionButton()
  ];

  return model;
};

const cteInvoicingItemsModel = () => {
  const model: Array<ITableModel> = [
    ...cteModelItems
  ];

  return model;
};

const cteInvoicingModelTableOpenProtocol = () => {
  const model: Array<ITableModel> = [
    ...cteModel
  ];

  return model;
};

export {
  cteInvoicingModelComplete,
  cteInvoicingModelTableOpenProtocol,
  cteInvoicingItemsModel
};